import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from "../header/header.component";

@Component({
  selector: 'app-bcp',
  imports: [FooterComponent, HeaderComponent],
  templateUrl: './bcp.component.html',
  styleUrl: './bcp.component.css'
})
//export class BcpComponent {}

export class BcpComponent implements OnInit{
  constructor(private titleService: Title){}
  ngOnInit(): void {
    this.titleService.setTitle("Banco de Crédito del Perú") //  Titulo de la pagina
  }
}